import { Box, Card, CardContent, IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import variables from "../../../../assets/styles/variables.module.scss";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { GroupOld, Prompt } from "../../../Types/common";


interface MyComponentProps {
  data:Prompt|GroupOld
  deleteFun:any
  editFun:any,
  hideEdit?:boolean,
  hideDelete?:boolean
}

const ExtraSmallCard:React.FC<MyComponentProps> = (props) => {
  const [hovered, setHovered] = useState(false);
  return (
    <Card
      //elevation={6}
      //variant="outlined"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      sx={{
        position: "relative",
        borderRadius: "12px",
        width: "100%",
        boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.1)",
        backgroundColor: "rgba(256, 256, 256, 0.7)",
        backdropFilter: "blur(5px)",
      }}
    >
      <CardContent
        sx={{
          padding: {
            xs: "8px", // Mobile
            sm: "16px", // Tablet
            md: "16px", // Desktop
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: 2,
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              background: variables.primaryColorLight,
              color: variables.whiteColor,
              borderRadius: "50%",
              width: "50px",
              height: "50px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 16 16"
            >
              <path
                fill="currentColor"
                d="M14 1.5a.5.5 0 0 0-1 0V2h-.5a.5.5 0 0 0 0 1h.5v.5a.5.5 0 0 0 1 0V3h.5a.5.5 0 0 0 0-1H14zm-8.61.63a.2.2 0 0 1 .06-.104C5.474 2.002 5.493 2 5.5 2s.026.002.052.026a.2.2 0 0 1 .059.104a4.2 4.2 0 0 0 1.135 2.124A4.2 4.2 0 0 0 8.87 5.39a.2.2 0 0 1 .104.059c.024.025.026.044.026.051s-.002.026-.026.052a.2.2 0 0 1-.104.058a4.2 4.2 0 0 0-2.124 1.137A4.2 4.2 0 0 0 5.611 8.87a.2.2 0 0 1-.059.104c-.026.024-.044.026-.051.026c-.008 0-.026-.002-.052-.026a.2.2 0 0 1-.058-.104a4.2 4.2 0 0 0-1.137-2.124A4.2 4.2 0 0 0 2.13 5.61a.2.2 0 0 1-.103-.059C2.003 5.526 2 5.507 2 5.501c0-.008.002-.026.026-.052a.2.2 0 0 1 .104-.059a4.2 4.2 0 0 0 2.123-1.136A4.2 4.2 0 0 0 5.391 2.13M5.5 1c-.576 0-.99.453-1.088.926a3.2 3.2 0 0 1-.865 1.62a3.2 3.2 0 0 1-1.62.865c-.473.098-.927.513-.926 1.091c.001.576.454.989.926 1.087c.426.088 1.067.31 1.62.864s.776 1.195.865 1.621c.098.473.512.926 1.089.926s.99-.454 1.089-.927c.088-.425.31-1.066.864-1.62a3.2 3.2 0 0 1 1.62-.864C9.547 6.491 10 6.077 10 5.5s-.453-.99-.926-1.09a3.2 3.2 0 0 1-1.62-.863a3.2 3.2 0 0 1-.864-1.62C6.49 1.452 6.078 1 5.5 1m5.44 4a2.1 2.1 0 0 1 0 1h.56A1.5 1.5 0 0 1 13 7.5v4a1.5 1.5 0 0 1-1.5 1.5h-4A1.5 1.5 0 0 1 6 11.5v-.56a2.1 2.1 0 0 1-1 0v.56A2.5 2.5 0 0 0 7.5 14h4a2.5 2.5 0 0 0 2.5-2.5v-4A2.5 2.5 0 0 0 11.5 5zM8 8.5a.5.5 0 0 1 .5-.5H11a.5.5 0 0 1 0 1H8.5a.5.5 0 0 1-.5-.5m.5 1.5a.5.5 0 0 0 0 1H10a.5.5 0 0 0 0-1zm-6 2a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 0 1H3v.5a.5.5 0 0 1-1 0V14h-.5a.5.5 0 0 1 0-1H2v-.5a.5.5 0 0 1 .5-.5"
              />
            </svg>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flex: 1,
              alignItems: "center",
            }}
          >
            <Box>
              <Typography
                gutterBottom
                variant="body1"
                sx={{
                  fontWeight: "500",
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 1, // Number of lines before truncation
                  textOverflow: "ellipsis",
                  height: "24px",
                  overflow: "hidden",
                  width: "250px",
                  wordBreak: "break-word",
                }}
              >
                {/* name */}
                {props.data.name}
              </Typography>
              <Typography 
                variant="body2"
                sx={{
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 2, // Number of lines before truncation
                  textOverflow: "ellipsis",
                  height: "42px",
                  overflow: "hidden",
                  wordBreak: "break-word",
                }}
              >
              {/* description */}
              {props.data.description}
              </Typography>
            </Box>
            <Box
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                display: hovered ? "flex" : "none",
                gap: 1,
              }}
            >
              {!props.hideEdit && 
                <IconButton aria-label="edit" size="small" onClick={()=>props.editFun(props.data)}>
                  <EditIcon fontSize="inherit" />
                </IconButton>
              }
              {!props.hideDelete && 
                <IconButton aria-label="delete" size="small" onClick={()=>props.deleteFun(props.data)}>
                  <DeleteIcon fontSize="inherit" />
                </IconButton>
              }
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ExtraSmallCard;
